import { render, staticRenderFns } from "./BackupNotesTable.vue?vue&type=template&id=05953dc8&"
import script from "./BackupNotesTable.vue?vue&type=script&lang=js&"
export * from "./BackupNotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports